import React from "react";
import { SbEditableBlok, sbEditable } from "@storyblok/storyblok-editable";
import clsx from "clsx";
import { getHeadingTwClass } from "../../../../utils/tailwindClassConverters/getHeadingTwClass";
import { getTextColorTwClass } from "../../../../utils/tailwindClassConverters/getTextColorTwClass";

export interface HeadingV2Props {
  id?: string;
  blok: Partial<SbEditableBlok> & {
    displayText: string;
    viewType: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
    tagType: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
    isBold?: boolean;
    isItalic?: boolean;
    color?: string;
  };
  additionalClasses?: string;
  className?: string;
  key?: string;
}
export function HeadingV2({
  id,
  blok: { displayText, viewType, tagType, isBold, isItalic, color, ...blokData },
  additionalClasses = "",
  className,
  key
}: HeadingV2Props) {
  const Element = tagType || "h4";
  const baseClasses = {
    "font-normal": !isBold,
    "font-bold": isBold,
    italic: isItalic,
    [getTextColorTwClass(color)]: color
  };

  const headingClassNames = clsx(additionalClasses || { [getHeadingTwClass(viewType)]: viewType }, baseClasses);
  return (
    <div className={className} key={key}>
      <Element id={id} className={headingClassNames} {...sbEditable(blokData as SbEditableBlok)}>
        {displayText}
      </Element>
    </div>
  );
}
